export default function useStyles(displayShadow: boolean) {
  return {
    fixedActions: (theme) => ({
      py: 3,
      [theme.breakpoints.up('sm')]: {
        pb: 5,
      },
      px: 2,
      position: 'fixed',
      zIndex: 2,
      display: 'flex',
      justifyContent: 'center',
      left: 0,
      bottom: 0,
      right: 0,
      borderTop: '1px solid',
      borderColor: theme.palette.grey.L80,
      backgroundColor: 'white',
      boxShadow: displayShadow ? '0px -1px 20px 0px rgba(0, 0, 0, 0.10)' : 'unset',
      transition: 'box-shadow 0.5s',
    }),
  };
}
